import emeraldBingHybridStyle from "@/assets/map-styles/emerald-bing-hybrid.json";
import { bingKey } from "@/constants";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

interface BingImageryResponse {
  resourceSets: Array<{
    resources: Array<{
      imageUrl: string;
    }>;
  }>;
}

interface TransformedBingTiles {
  version: number;
  sources: Record<string, unknown>;
  layers: unknown[];
  [key: string]: unknown;
}

export const bingApi = createApi({
  reducerPath: "bingApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://dev.virtualearth.net/REST/V1/",
  }),
  keepUnusedDataFor: 300, // 5 minutes cache
  tagTypes: ["BingTiles"],
  endpoints: (builder) => ({
    getEmeraldBingTiles: builder.query<TransformedBingTiles, void>({
      query: () => ({
        url: `Imagery/Metadata/Aerial?output=json&include=ImageryProviders&key=${bingKey}`,
        method: "GET",
      }),
      transformResponse: (response: BingImageryResponse) => {
        const tiles = response.resourceSets[0].resources[0].imageUrl
          .replace("{subdomain}", "t0")
          .replace("http://", "https://");

        return {
          ...emeraldBingHybridStyle,
          sources: {
            ...emeraldBingHybridStyle.sources,
            "bing-tiles": {
              ...emeraldBingHybridStyle.sources["bing-tiles"],
              tiles: [tiles],
            },
          },
        };
      },
      providesTags: ["BingTiles"],
    }),
  }),
});

export const { useGetEmeraldBingTilesQuery } = bingApi;
